"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenUriResponseT = exports.OpenUriResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class OpenUriResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsOpenUriResponse(bb, obj) {
        return (obj || new OpenUriResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsOpenUriResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new OpenUriResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    success() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startOpenUriResponse(builder) {
        builder.startObject(1);
    }
    static addSuccess(builder, success) {
        builder.addFieldInt8(0, +success, +false);
    }
    static endOpenUriResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createOpenUriResponse(builder, success) {
        OpenUriResponse.startOpenUriResponse(builder);
        OpenUriResponse.addSuccess(builder, success);
        return OpenUriResponse.endOpenUriResponse(builder);
    }
    unpack() {
        return new OpenUriResponseT(this.success());
    }
    unpackTo(_o) {
        _o.success = this.success();
    }
}
exports.OpenUriResponse = OpenUriResponse;
class OpenUriResponseT {
    constructor(success = false) {
        this.success = success;
    }
    pack(builder) {
        return OpenUriResponse.createOpenUriResponse(builder, this.success);
    }
}
exports.OpenUriResponseT = OpenUriResponseT;
